module.exports = __webpack_public_path__ + "img/logo-camp.6487f429.png";